import axios from 'axios';

const { handleOAuthFlow } = require('./oauth_flow');

const nexum_sym = process.env.REACT_APP_NEXUM_SYM;
const nexum_api_key = process.env.REACT_APP_NEXUM_API_KEY;
const nexum_dev_endpoint = process.env.REACT_APP_NEXUM_DEV_ENDPOINT;
const nexum_ac = process.env.REACT_APP_NEXUM_AC;
const plugin_client_id = process.env.REACT_APP_PLUGIN_CLIENTID;
const plugin_client_secret = process.env.REACT_APP_PLUGIN_CLIENTSECRET;
const plugin_environment = process.env.REACT_APP_PLUGIN_ENVIRONMENT;
const plugin_redirecturi = process.env.REACT_APP_PLUGIN_REDIRECTURI;

const config = {
  headers: {
    'Authorization': `Bearer ${nexum_api_key}`,
    'Content-Type': 'application/json'
  }
};

// Utility function to get account number
const getMemberInfo = async () => {
  const timeout = 5000;

  // Check for existing authentication
  const existingAuth = localStorage.getItem('auth_data');
  if (existingAuth) {
    try {
      const authData = JSON.parse(existingAuth);
      // Check if the auth data is still valid (you might want to add expiration check here)
      return authData;
    } catch (e) {
      console.error('Error parsing stored auth data:', e);
      localStorage.removeItem('auth_data');
    }
  }

  // Get query parameters from URL
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state');
  
  try {
    // Validate required parameters
    if (!plugin_client_id || !plugin_client_secret || !plugin_environment) {
        throw new Error('Missing required parameters');
    } 

    // Create a promise that rejects after timeout
    const timeoutPromise = new Promise((_, reject) => {
        setTimeout(() => {
            reject(new Error(`Request timed out after ${timeout}ms`));
        }, timeout);
    });

    const req = {
      code: code,
      state: state
    }

    const requestPromise = handleOAuthFlow({
      plugin_environment,
      plugin_client_id,
      plugin_client_secret,
      plugin_redirecturi,
      req
    });

    // Race between the timeout and the actual request
    const result = await Promise.race([requestPromise, timeoutPromise]);
    
    if (result) {
      if (result.results === 'OK'){
        // Store the successful authentication data
        localStorage.setItem('auth_data', JSON.stringify(result));
        return result;
      } else if (result.results === 'ERROR'){
          throw new Error(result.error);
      } else {
          // Store state and code_verifier in localStorage
          localStorage.setItem(`STATE_${result.state}`, result.code_verifier);
          // Redirect to the authorization URL
          window.location.href = result.redirect_url;
          return null;        
      }
    }
  } catch(error) {
      return {
          results: "ERROR",
          error: error.message,
          member_number: "",
          first_name: "",
          middle_name: "",
          last_name: "",
          user_type: "",
          user_name: "",
          phone_number: ""
      };
  }
};


const generateProPayURL = async (loanData) => {
  try {
    const payURLjson = {
      targetId: "12045976",
      integrationId: `${loanData.memreflink}_${loanData.account_number}_${loanData.loan_id}`,
      groupIntegrationId: loanData.memreflink,
      accountNumber: `${loanData.account_number}-${loanData.loan_id}-${loanData.loan_description}`,
      firstName: loanData.first_name,
      lastName: loanData.last_name,
      email: loanData.email,
      phone: loanData.phone,
      taxId: loanData.taxid,
      payer: {
        loanId: loanData.loan_id,
        loanDescription: loanData.loan_description,
        customerNumber: loanData.account_number,
        accountType: "1",
        memberNumber: loanData.memreflink
      }
    };

    const apiProPayURL = "https://api.aptx.cm/endpoint/service/api-v1/createAccountPerson?token=5LGKWAHZ3NJFD9Q5";
    const apiHeaders = { "Content-Type": "text/plain" };

    const response = await axios.post(apiProPayURL, JSON.stringify(payURLjson), { headers: apiHeaders });
    
    if (!response.data || !response.data.link) {
      return "ERROR";
    }

    return response.data.link;
  } catch (error) {
    return "ERROR";
  }
};

export const fetchDashboardData = async () => {
  try {
    const member_info = await getMemberInfo();
    
    if (!member_info || member_info.results === "ERROR") {
      throw new Error(member_info?.error || "Failed to get member information");
    }
    
    const nexum_body = {
        "Credentials": {
          "AdministrativeCredentials": {
              "Password": nexum_ac
          }
        },
        "Header": {
            "MessageID": "1",
            "RGState": "GETLIST"
        },
        "Body": {
            "File": "MSJ.SYMX.PAYLOANWITHCARD.PND",
            "RGSession": 1,
            "UserDefinedParameters": {
                "RGUserChr": [
                    {
                        "ID": "1",
                        "Value": member_info.member_number.padStart(10,"0")
                    }
                ]
            }
        }
      };

    const url = `${nexum_dev_endpoint}nexum/${nexum_sym}/2022.01/poweron/executePowerOn`;
    const response = await axios.post(url, nexum_body, config);
    
    return JSON.parse(response.data.Body.RGLines);
  } catch (error) {
    throw error;
  }
};

export const clearAuth = () => {
  localStorage.removeItem('auth_data');
  // Clear any other auth-related items
  const keysToRemove = [];
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key.startsWith('STATE_')) {
      keysToRemove.push(key);
    }
  }
  keysToRemove.forEach(key => localStorage.removeItem(key));
};

export { generateProPayURL };

